import { render, staticRenderFns } from "./BuySiteModal.vue?vue&type=template&id=4c073879&"
import script from "./BuySiteModal.vue?vue&type=script&lang=js&"
export * from "./BuySiteModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports